import { render, staticRenderFns } from "./MedicalSurgery.vue?vue&type=template&id=3de20a15&scoped=true"
import script from "./MedicalSurgery.vue?vue&type=script&lang=js"
export * from "./MedicalSurgery.vue?vue&type=script&lang=js"
import style0 from "./MedicalSurgery.vue?vue&type=style&index=0&id=3de20a15&prod&scoped=true&lang=css"
import style1 from "./MedicalSurgery.vue?vue&type=style&index=1&id=3de20a15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de20a15",
  null
  
)

export default component.exports